<template>
  <div class="qd-gl-container">
    <!-- 顶部导航栏 -->
    <van-nav-bar
      class="custom-nav-bar"
      title="签到管理"
      left-text="返回"
      left-arrow
      @click-left="onClickLeft"
    >
      <template #right>
        <van-icon name="wap-home" size="20" @click="goHome" />
      </template>
    </van-nav-bar>

    <!-- 主体内容 -->
    <div class="main-content">
      <!-- 证件号输入区域 -->
      <div class="input-card">
        <div class="card-header">
          <van-icon name="idcard" class="header-icon" />
          <span class="header-title">请输入证件号</span>
        </div>
        <van-field
          v-model="zjh"
          class="zjh-field"
          label="证件号"
          placeholder="请输入证件号"
          clearable
          @input="handleZjhInput"
        />
        <div class="search-btn-wrapper">
          <van-button
            type="primary"
            block
            class="search-btn"
            :disabled="zjh.trim().length === 0 || isLoading"
            @click="queryRyInfo"
          >
            <van-icon name="search" />
            查询人员信息
          </van-button>
        </div>
      </div>

      <!-- 人员信息列表：每条报名记录一张卡片 -->
      <div v-if="ryList.length > 0" class="info-card">
        <!-- 签到状态区域（固定在顶部，只展示一次） -->
        <div class="card-header">
          <van-icon name="contact" class="header-icon" />
          <span class="header-title">签到信息</span>
        </div>

        <div class="status-row">
          <span class="info-label">签到状态</span>
          <span
            class="status-badge"
            :class="qdState.isQd ? 'status-signed' : 'status-unsigned'"
          >
            <van-icon :name="qdState.isQd ? 'success' : 'cross'" />
            {{ qdState.isQd ? "已签到" : "未签到" }}
          </span>
        </div>
        <div class="info-row" v-if="qdState.isQd && qdState.qdSj.length > 0">
          <span class="info-label">签到时间</span>
          <span class="info-value">{{ qdState.qdSj }}</span>
        </div>
        <div class="action-btn-group">
          <van-button
            v-if="!qdState.isQd"
            type="primary"
            block
            class="qd-btn"
            :disabled="qdState.submitting"
            @click="doQd"
          >
            <van-icon name="passed" />
            签到
          </van-button>
          <van-button
            v-if="qdState.isQd"
            type="danger"
            block
            class="cancel-qd-btn"
            :disabled="qdState.submitting"
            @click="doCancelQd"
          >
            <van-icon name="revoke" />
            取消签到
          </van-button>
        </div>
      </div>

      <!-- 报名记录列表 -->
      <div v-for="(item, index) in ryList" :key="index" class="info-card">
        <div class="card-header">
          <van-icon name="contact" class="header-icon" />
          <span class="header-title">
            {{
              ryList.length > 1
                ? "报名记录 " + (index + 1) + " / " + ryList.length
                : "人员基本信息"
            }}
          </span>
        </div>

        <!-- 动态遍历该条记录的所有字段 -->
        <div
          v-for="field in getFieldList(item)"
          :key="field.key"
          class="info-row"
        >
          <span class="info-label">{{ field.label }}</span>
          <span class="info-value">{{ field.value }}</span>
        </div>
      </div>

      <!-- 未查到人员提示 -->
      <div class="empty-tip" v-if="isQueried && ryList.length === 0">
        <van-icon name="warning-o" class="empty-icon" />
        <p>未查询到该证件号对应的人员信息</p>
        <p class="empty-sub">请确认证件号是否正确</p>
      </div>
    </div>

    <loading-com />
  </div>
</template>

<script>
import LoadingCom from "../commonCom/LoadingCom.vue";

// 需要隐藏的内部字段（不对用户展示）
const HIDDEN_KEYS = new Set([
  "SSID",
  "XMID",
  "RYID",
  "DWID",
  "SSLX",
  "SSLXMC",
  "XB",
  "ISQD",
  "QDSJ",
  "SR",
  "SRTXT",
  "CREATETIME"
]);

// 固定字段的中文标签映射（优先使用；没配置的 key 直接显示原 key）
const LABEL_MAP = {
  RYXM: "姓名",
  XB_TXT: "性别",
  SFZH: "证件号",
  TEL: "手机号",
  AGE: "年龄",
  XMQC: "参赛项目",
  XMJC: "项目简称",
  DWQC: "队伍全称",
  DWJC: "队伍简称"
};

// 展示顺序优先级（越靠前越先渲染）
const KEY_ORDER = [
  "RYXM",
  "XB_TXT",
  "AGE",
  "SFZH",
  "TEL",
  "队名",
  "DWQC",
  "DWJC",
  "XMQC",
  "XMJC",
  "比赛服尺码"
];

export default {
  name: "QdGlIndex",
  components: { LoadingCom },
  data() {
    return {
      ssid: "",
      zjh: "",
      ryList: [], // 查询结果数组（纯展示，不含签到状态）
      qdState: {
        // 签到状态统一维护，与报名记录列表无关
        isQd: false,
        qdSj: "",
        submitting: false
      },
      isQueried: false,
      isLoading: false,
      utilPost: null
    };
  },
  created() {
    this.utilPost = this.$util.handler;
    this.ssid = this.$route.query.ssid || "";
  },
  methods: {
    onClickLeft() {
      this.$router.go(-1);
    },
    goHome() {
      const routeValue = localStorage.getItem("routeValue");
      if (routeValue) {
        this.$router.push({ path: "/" + routeValue });
      } else {
        this.$router.push({ path: "/" });
      }
    },

    // 证件号输入时过滤非法字符，并清空上次结果
    handleZjhInput(value) {
      this.zjh = value.replace(/[^A-Za-z0-9]/g, "");
      if (this.ryList.length > 0) {
        this.ryList = [];
        this.qdState = { isQd: false, qdSj: "", submitting: false };
        this.isQueried = false;
      }
    },

    // 查询人员信息
    queryRyInfo() {
      const zjh = this.zjh.trim();
      if (zjh.length === 0) {
        this.$notify({
          type: "warning",
          message: "请输入证件号",
          duration: 2000
        });
        return;
      }
      this.isLoading = true;
      this.isQueried = false;
      this.ryList = [];
      this.qdState = { isQd: false, qdSj: "", submitting: false };

      const paramData = {
        headerData: {
          ssid: this.ssid,
          op: "wapGL",
          methodName: "getRyInfoBySfzh"
        },
        busData: { SFZH: zjh }
      };
      this.utilPost.paramData = paramData;
      this.utilPost
        .sendPost()
        .then(data => {
          this.isLoading = false;
          this.isQueried = true;
          if (!data.isSuccess) {
            this.$notify({ type: "danger", message: data.msg, duration: 3000 });
            return;
          }
          const list = data.content || [];
          // 纯数据展示，不附加签到状态字段
          this.ryList = list.map(item => {
            const row = Object.assign({}, item);
            // 将性别转成文本，方便展示
            this.$set(
              row,
              "XB_TXT",
              item.XB === "M" ? "男" : item.XB === "W" ? "女" : ""
            );
            return row;
          });
          // 签到状态从 lsData 读取
          const lsData = data.lsData || {};
          this.qdState.isQd = lsData.ISQD === "1";
          this.qdState.qdSj = lsData.QDSJ || "";
        })
        .catch(() => {
          this.isLoading = false;
          this.isQueried = true;
        });
    },

    /**
     * 将一条记录转换成 { key, label, value } 数组，用于动态渲染
     * - 过滤掉 HIDDEN_KEYS 和以 _ 开头的内部字段
     * - 按 KEY_ORDER 排序，其余字段追加在后面
     * - 空值不展示
     */
    getFieldList(item) {
      // 收集所有可展示的 key
      const allKeys = Object.keys(item).filter(k => {
        if (k.startsWith("_")) return false;
        if (HIDDEN_KEYS.has(k)) return false;
        const v = item[k];
        if (v === null || v === undefined || v === "") return false;
        return true;
      });

      // 按 KEY_ORDER 排序
      const ordered = KEY_ORDER.filter(k => allKeys.includes(k));
      const rest = allKeys.filter(k => !KEY_ORDER.includes(k));
      const sortedKeys = [...ordered, ...rest];

      return sortedKeys.map(k => ({
        key: k,
        label: LABEL_MAP[k] || k,
        value: k === "AGE" ? item[k] + " 岁" : item[k]
      }));
    },

    // 签到（使用第一条记录的 RYID，签到针对的是人不是某条报名记录）
    doQd() {
      this.qdState.submitting = true;
      const firstItem = this.ryList[0] || {};
      const paramData = {
        headerData: {
          ssid: this.ssid,
          op: "wapGL",
          methodName: "doQd"
        },
        busData: {
          SFZH: this.zjh.trim(),
          ISQD: "1"
        }
      };
      this.utilPost.paramData = paramData;
      this.utilPost
        .sendPost()
        .then(data => {
          this.qdState.submitting = false;
          if (!data.isSuccess) {
            this.$notify({ type: "danger", message: data.msg, duration: 3000 });
            return;
          }
          this.$notify({
            type: "success",
            message: "签到成功",
            duration: 2000
          });
          this.qdState.isQd = true;
          this.qdState.qdSj =
            data.content && data.content.QDSJ
              ? data.content.QDSJ
              : this.utilPost.formatDate(new Date(), "yyyy-MM-dd HH:mm:ss");
        })
        .catch(() => {
          this.qdState.submitting = false;
        });
    },

    // 取消签到
    doCancelQd() {
      this.$dialog
        .confirm({
          title: "提示",
          message: "确认要取消该人员的签到吗？"
        })
        .then(() => {
          this.qdState.submitting = true;
          const firstItem = this.ryList[0] || {};
          const paramData = {
            headerData: {
              ssid: this.ssid,
              op: "wapGL",
              methodName: "cancelQd"
            },
            busData: {
              SFZH: this.zjh.trim(),
              ISQD: "0"
            }
          };
          this.utilPost.paramData = paramData;
          this.utilPost
            .sendPost()
            .then(data => {
              this.qdState.submitting = false;
              if (!data.isSuccess) {
                this.$notify({
                  type: "danger",
                  message: data.msg,
                  duration: 3000
                });
                return;
              }
              this.$notify({
                type: "success",
                message: "已取消签到",
                duration: 2000
              });
              this.qdState.isQd = false;
              this.qdState.qdSj = "";
            })
            .catch(() => {
              this.qdState.submitting = false;
            });
        })
        .catch(() => {});
    }
  }
};
</script>

<style scoped>
/* ====== 整体容器 ====== */
.qd-gl-container {
  min-height: 100vh;
  background: #f5f6fa;
  font-size: 13px;
}

/* ====== 顶部导航 ====== */
.custom-nav-bar {
  background: linear-gradient(135deg, #185f9b 0%, #1a6ba8 100%);
}
.custom-nav-bar >>> .van-nav-bar__title {
  color: #fff;
  font-weight: 700;
  font-size: 14px;
}
.custom-nav-bar >>> .van-nav-bar__text,
.custom-nav-bar >>> .van-icon {
  color: #fff;
}

/* ====== 主体 ====== */
.main-content {
  padding: 0.75rem;
}

/* ====== 卡片公共 ====== */
.input-card,
.info-card {
  background: #fff;
  border-radius: 10px;
  box-shadow: 0 2px 12px rgba(24, 95, 155, 0.12);
  overflow: hidden;
  margin-bottom: 0.75rem;
}

.card-header {
  display: flex;
  align-items: center;
  gap: 0.4rem;
  padding: 0.6rem 0.875rem;
  background: linear-gradient(135deg, #185f9b 0%, #1a6ba8 100%);
}
.header-icon {
  font-size: 1rem;
  color: #fff;
}
.header-title {
  font-size: 13px;
  font-weight: 700;
  color: #fff;
}

/* ====== 证件号输入 ====== */
.zjh-field {
  border-bottom: 1px solid #f0f0f0;
}
.zjh-field >>> .van-field__label {
  color: #666;
  font-weight: 500;
  font-size: 13px;
}
.zjh-field >>> .van-field__control {
  color: #2c3e50;
  font-size: 13px;
}

.search-btn-wrapper {
  padding: 0.6rem 0.875rem;
}
.search-btn {
  background: linear-gradient(135deg, #185f9b 0%, #1a6ba8 100%);
  border: none;
  border-radius: 7px;
  font-weight: 600;
  height: 2.25rem;
  font-size: 13px;
  box-shadow: 0 4px 12px rgba(24, 95, 155, 0.3);
}
.search-btn:active {
  transform: scale(0.98);
}

/* ====== 信息行 ====== */
.info-row,
.status-row {
  display: flex;
  align-items: center;
  padding: 0.55rem 0.875rem;
  border-bottom: 1px solid #f5f5f5;
}
.info-label {
  flex-shrink: 0;
  width: 5rem;
  color: #6b7280;
  font-size: 12px;
  font-weight: 500;
}
.info-value {
  flex: 1;
  color: #1f2937;
  font-size: 13px;
  font-weight: 500;
  word-break: break-all;
}

/* ====== 签到状态徽标 ====== */
.status-badge {
  display: inline-flex;
  align-items: center;
  gap: 0.25rem;
  padding: 0.2rem 0.6rem;
  border-radius: 999px;
  font-size: 12px;
  font-weight: 600;
}
.status-signed {
  background: #d1fae5;
  color: #065f46;
}
.status-unsigned {
  background: #fee2e2;
  color: #991b1b;
}

/* ====== 操作按钮组 ====== */
.action-btn-group {
  padding: 0.6rem 0.875rem;
}
.qd-btn {
  background: linear-gradient(135deg, #10b981 0%, #059669 100%);
  border: none;
  border-radius: 7px;
  font-weight: 700;
  height: 2.25rem;
  font-size: 13px;
  box-shadow: 0 4px 12px rgba(16, 185, 129, 0.35);
}
.qd-btn:active {
  transform: scale(0.98);
}
.cancel-qd-btn {
  background: linear-gradient(135deg, #ef4444 0%, #dc2626 100%);
  border: none;
  border-radius: 7px;
  font-weight: 700;
  height: 2.25rem;
  font-size: 13px;
  box-shadow: 0 4px 12px rgba(239, 68, 68, 0.35);
}
.cancel-qd-btn:active {
  transform: scale(0.98);
}

/* ====== 空提示 ====== */
.empty-tip {
  text-align: center;
  padding: 2rem 1rem;
  color: #6b7280;
}
.empty-icon {
  font-size: 2.5rem;
  color: #d1d5db;
  margin-bottom: 0.75rem;
  display: block;
}
.empty-tip p {
  margin: 0.25rem 0;
  font-size: 13px;
}
.empty-sub {
  font-size: 12px;
  color: #9ca3af;
}
</style>



// WEBPACK FOOTER //
// src/components/qdGlIndex/QdGlIndex.vue